module.exports = __webpack_public_path__ + "static/media/RGBInactive.a8621505.png";